import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { WorkplaceSelectStore } from './workplace-select.store';
import { FormGroup } from '@angular/forms';
import { ServiceTypeGridItemObject, WorkplaceGridItemObject } from '@it2go/types';
import { startWith, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import config from '../../../../../../config/config';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { Router } from '@angular/router';
import { serviceUri } from '../../../../../../utils/router.utils';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-workplace-select',
    templateUrl: 'workplace-select.component.html',
    styleUrl: 'workplace-select.component.scss',
    providers: [WorkplaceSelectStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectInputComponent,
        AsyncPipe,
    ],
})
export class WorkplaceSelectComponent extends SubscriptionComponent implements OnInit, OnChanges {

    protected readonly store = inject(WorkplaceSelectStore);
    private readonly router = inject(Router);

    @Input() form!: FormGroup;
    @Input() id = 'workplaceId';
    @Input() label = 'workplace.label';
    @Input() showLink: boolean = true; // TODO dodělat link
    @Input() disabled: boolean = false;
    @Input() serviceId!: number;

    @Output() itemSelected = new EventEmitter<WorkplaceGridItemObject>();

    public searchSubject = new Subject<string>();

    constructor() {
        super();
        this.fetchItems();
        this.subs.push(
            this.searchSubject
                .pipe(debounceTime(config.debounceTime))
                .subscribe((search) => this.fetchItems(search)),
        );
    }

    public async ngOnInit(): Promise<void> {
        this.subs.push(
            this.form.controls[this.id].valueChanges
                .pipe(startWith(null))
                .subscribe(async (itemId: string | null) => {
                    const id = itemId || this.form.value[this.id];
                    if (id && itemId != this.form.value[this.id]) {
                        const items = await this.store.get(this.store.items$);
                        if (items.length) {
                            const item = items.find((it: ServiceTypeGridItemObject) => it.id == id);
                            if (item) this.itemSelected.emit(item);
                            // } else { // Protože je málo prvků, tak se nedotahuje konkrétní, ale vždy stránka
                            //     this.store.api.getWorkplaces(FilterBuilder.singleItem({ id }));
                        }
                    }
                }),
        );
    }

    public filter(search: string): void {
        this.searchSubject.next(search);
    }

    public async ngOnChanges(): Promise<void> {
        await this.fetchItems();
    }

    protected async goTo(): Promise<void> {
        await this.router.navigateByUrl(serviceUri(this.serviceId, `workplaces/${this.form.value[this.id]}`));
    }

    private async fetchItems(search: string | null = null) {
        if (!this.serviceId) return;

        this.store.api.getWorkplaces(FilterBuilder.filter({
            serviceId: this.serviceId,
            limit: 100,
            search,
        }));
    }

}
